/* cr-home.js - homepage behaviours for sections cr-home-00..13 (2026-09-24).
   Replaces what the GemPages engine (assets/gpwc-bundle.js, 540 KB) used to do on this page, and nothing else:
   1. below-fold images (same rules as CR-BELOWFOLD-DEFER, for data-crh-* instead of data-crl-*)
   2. "#..." links and the "Get the Detox & Calm Kit" buttons: smooth scroll, hash updated without a history entry
   3. carousels: video carousel (s03), zeolite/sulforaphane cards (s05), kids gallery with loop (s09)
   4. "As seen on" logo strip (s06): same speed and loop maths as before
   5. video (s03): src/poster set when it comes near the screen, thumbnail click plays it
   No dependencies. Every part is scoped to [data-crh] section roots, so it is a no-op anywhere else. */
(function () {
  'use strict';
  var D = document, W = window;
  if (!D.querySelector('[data-crh]')) return;
  function onReady(fn) { if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', fn); else fn(); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function raf(fn) { return (W.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(fn); }

  /* ---------------------------------------------------------------- 1. below-fold images
     Sections ship these images parked in data-crh-* behind same-size transparent placeholders, so nothing moves.
     They go back when their section is within 1500px of the screen, but only after the page has settled
     (load, first scroll/touch, or 8 s). Carousel and logo-strip images that are on screen for this device load
     eagerly (off-screen slides would otherwise stay blank on swipe); the kids gallery manages its own. */
  var CAR = '[data-crh-carousel]:not([data-crh-lazy-slides]), [data-crh-el="marquee"]';
  function mv(el, from, to) { var v = el.getAttribute(from); if (v === null) return; el.setAttribute(to, v); el.removeAttribute(from); }
  function restoreImages(root) {
    each(root.querySelectorAll('source[data-crh-srcset]'), function (s) { mv(s, 'data-crh-srcset', 'srcset'); });
    each(root.querySelectorAll('img[data-crh-src]'), function (i) {
      var lz = i.getAttribute('data-crh-loading'); i.removeAttribute('data-crh-loading');
      i.setAttribute('loading', (i.closest(CAR) && i.getClientRects().length) ? 'eager' : (lz || 'lazy'));
      mv(i, 'data-crh-srcset', 'srcset'); mv(i, 'data-crh-src', 'src');
    });
  }
  function outerSection(el) { var s = el.closest('.shopify-section'), up; while (s && s.parentElement && (up = s.parentElement.closest('.shopify-section'))) s = up; return s || D.body; }
  function deferImages() {
    var SEL = 'img[data-crh-src], source[data-crh-srcset]';
    if (!D.querySelector(SEL)) return;
    var started = false;
    function start() {
      if (started) return; started = true;
      var roots = [];
      each(D.querySelectorAll(SEL), function (el) { var s = outerSection(el); if (roots.indexOf(s) < 0) roots.push(s); });
      if (!('IntersectionObserver' in W)) { roots.forEach(restoreImages); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); restoreImages(e.target); } });
      }, { rootMargin: '1500px 0px' });
      roots.forEach(function (s) { io.observe(s); });
    }
    if (D.readyState === 'complete' || W.scrollY > 0) { start(); return; }
    W.addEventListener('load', start, { once: true });
    ['scroll', 'touchstart', 'pointerdown', 'keydown', 'wheel'].forEach(function (ev) { W.addEventListener(ev, start, { once: true, passive: true }); });
    setTimeout(start, 8000);
  }

  /* ---------------------------------------------------------------- 2. "#..." links and scroll buttons
     Same behaviour the page had: smooth scroll to the target, "#scroll-to-top" also scrolls the window to the top
     first, and the hash is written 300 ms later with replaceState (no extra history entry). A URL that arrives
     with a hash scrolls smoothly to its target once the page is parsed. */
  function hashLinks() {
    function idOf(h) { return (h.indexOf('#el-') === 0 ? h.replace('#el-', '#') : h).substring(1); }
    function byId(id) { try { return D.querySelector("[id='" + id + "']"); } catch (e) { return null; } }
    function go(id, target) {
      if (id === 'scroll-to-top') W.scrollTo({ top: 0, behavior: 'smooth' });
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        setTimeout(function () { var u = new URL(W.location.toString()); u.hash = '#' + id; history.replaceState(null, '', u.toString()); }, 300);
      }
    }
    each(D.querySelectorAll('a[href^="#"]'), function (a) {
      var h = a.getAttribute('href'); if (!h || h === '#') return;
      var id = idOf(h), target = byId(id);
      a.addEventListener('click', function (e) { e.preventDefault(); go(id, target); });
    });
    /* the section buttons are <button href="#..."> with a hidden <a> twin; clicking the button clicks the twin */
    each(D.querySelectorAll('[data-crh] [data-crh-el="button"]'), function (wrap) {
      var btn = wrap.querySelector('.crh-button-base'), twin = wrap.querySelector('.crh-trigger-button-link');
      var link = btn && btn.getAttribute('href');
      if (!btn || !twin || !link || link.charAt(0) !== '#') return;
      if ((btn.getAttribute('target') || '_self') !== '_self') return;
      btn.addEventListener('click', function () { twin.click(); });
    });
  }
  (function hashOnArrival() {
    var h = W.location.hash; if (!h) return;
    try { W.history.scrollRestoration = 'manual'; } catch (e) {}
    onReady(function () {
      var id = (h.indexOf('#el-') === 0 ? h.replace('#el-', '#') : h).substring(1), t;
      try { t = D.querySelector("[id='" + id + "']"); } catch (e) { t = null; }
      setTimeout(function () { if (t) t.scrollIntoView({ behavior: 'smooth' }); }, 100);
    });
  })();

  /* ---------------------------------------------------------------- 3. carousels */
  function devBy(w) { return w >= 1025 ? 'desktop' : (w >= 768 ? 'tablet' : 'mobile'); }
  var easeIn = function (t) { return t * t * t; }, easeOutQuint = function (t) { return 1 + (--t) * t * t * t * t; };

  function dotsUpdate(dots, idx) {
    dots.forEach(function (d, k) {
      var on = k === idx;
      d.classList.toggle('crh-carousel-dot--active', on); d.classList.toggle('crh-slider-dot-active', on); d.classList.toggle('crh-slider-dot-inactive', !on);
      d.style.backgroundColor = on ? 'var(--crh-c-line-3, line-3)' : 'var(--crh-c-bg-1, bg-1)';
    });
  }
  function arrowState(btn, hide) {
    if (!btn) return;
    btn.setAttribute('data-hidden', hide ? 'true' : 'false'); btn.disabled = !!hide;
    if (hide) btn.style.setProperty('visibility', 'hidden', 'important');
    else { btn.style.removeProperty('visibility'); btn.style.removeProperty('--v'); }
  }
  /* a drag must not turn into a click on whatever is under the finger (thumbnail play, links) */
  function swallowNextClick(el) {
    var h = function (e) { e.stopPropagation(); e.preventDefault(); el.removeEventListener('click', h, true); };
    el.addEventListener('click', h, true); setTimeout(function () { el.removeEventListener('click', h, true); }, 400);
  }

  /* 3a. one slide per view, no loop (s03 video carousel, s05 cards). Moves the slide row with a CSS transition
     (500 ms ease-in), swipe/drag follows the finger with edge resistance, a quick flick or a drag past half a
     slide changes slide. */
  function RowCarousel(root, conf) {
    var box = root.querySelector('[id^="crh-carousel-"]'); if (!box) return;
    var row = box.querySelector('.crh-slider-wrapper'); if (!row) return;
    var slides = [].slice.call(row.children).filter(function (s) { return s.classList.contains('crh-slider-item'); });
    var back = root.querySelector('.crh-carousel-action-back'), next = root.querySelector('.crh-carousel-action-next');
    var dots = [].slice.call(root.querySelectorAll('.crh-carousel-dot'));
    var n = slides.length, idx = 0, step = 0, x = 0, ready = false;
    function layout() {
      var d = devBy(W.innerWidth), pv = conf.pv[d] || 1, sp = conf.sp[d] || 0, w = box.clientWidth;
      if (!w) { ready = false; return; }
      var sw = (w - sp * (pv - 1)) / pv; step = sw + sp;
      slides.forEach(function (s) { s.style.width = sw + 'px'; s.style.marginRight = sp + 'px'; });
      row.style.transitionTimingFunction = 'ease-in';
      if (!ready) { ready = true; update(); }
      setX(-idx * step, 0);
    }
    function setX(px, dur) {
      x = px; row.style.transitionDuration = dur + 'ms';
      if (px === 0 && !row.style.transform) return;
      row.style.transform = 'translate3d(' + px + 'px, 0px, 0px)';
    }
    function update() { arrowState(back, idx === 0); arrowState(next, idx === n - 1); dotsUpdate(dots, idx); }
    function goTo(i) { if (!ready) return; idx = Math.max(0, Math.min(n - 1, i)); setX(-idx * step, conf.speed); update(); }
    if (back) back.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    row.addEventListener('transitionend', function () { row.style.transitionDuration = '0ms'; });
    // drag: touch and mouse. Like the old slider: the direction is decided after 5px, and the distance is counted
    // from that point, so a slow drag has to cover half a slide (a quick flick needs less) to change slide
    var g = null;
    function down(px, py) {
      if (!ready || !conf.drag[devBy(W.innerWidth)]) return;
      g = { x0: px, y0: py, t0: Date.now(), start: x, axis: null, moved: false };
      row.style.transitionDuration = '0ms';
    }
    function move(px, py, ev) {
      if (!g) return;
      var dx = px - g.x0, dy = py - g.y0;
      if (g.axis === null) {
        if (dx * dx + dy * dy < 25) return;
        g.axis = (Math.atan2(Math.abs(dy), Math.abs(dx)) * 180 / Math.PI) > 45 ? 'y' : 'x';
        if (g.axis === 'x') { g.x0 = px; g.y0 = py; if (ev.cancelable) ev.preventDefault(); return; }
      }
      if (g.axis !== 'x') { g = null; return; }
      if (ev.cancelable) ev.preventDefault();
      g.moved = true;
      var min = -(n - 1) * step, t = g.start + dx;
      if (t > 0) t = -1 + Math.pow(t + 1, 0.85);
      else if (t < min) t = min + 1 - Math.pow(min - t + 1, 0.85);
      setX(t, 0);
    }
    function up() {
      if (!g) return;
      var s = g; g = null;
      if (!s.moved) return;
      swallowNextClick(root);
      var diff = x - s.start, dir = diff < 0 ? 1 : -1, quick = (Date.now() - s.t0) < 300;
      var from = Math.round(-s.start / step);
      if (quick && Math.abs(diff) > 0) goTo(from + dir);
      else if (Math.abs(diff) >= step * 0.5) goTo(from + dir * Math.max(1, Math.round(Math.abs(diff) / step)));
      else goTo(from);
    }
    box.addEventListener('touchstart', function (e) { var p = e.touches[0]; down(p.clientX, p.clientY); }, { passive: true });
    box.addEventListener('touchmove', function (e) { var p = e.touches[0]; move(p.clientX, p.clientY, e); }, { passive: false });
    box.addEventListener('touchend', up); box.addEventListener('touchcancel', up);
    box.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return; down(e.clientX, e.clientY);
      if (g && !(e.target.closest && e.target.closest('input, select, option, textarea, button, video, label'))) e.preventDefault();
    });
    W.addEventListener('mousemove', function (e) { if (g) move(e.clientX, e.clientY, e); });
    W.addEventListener('mouseup', up);
    layout();
    W.addEventListener('resize', layout);
  }

  /* 3b. the kids gallery (s09): several photos in view, loops. Each photo is placed with its own transform
     (a photo that leaves one end re-enters at the other), arrows animate 500 ms, a swipe moves one photo in the
     swipe direction. A photo loads when its slide is on screen, at 1.5x its on-screen width (as before); once
     someone touches the gallery or uses an arrow, the photo on either side is fetched too, so no blank slides. */
  function LoopCarousel(root, conf) {
    var box = root.querySelector('[id^="crh-carousel-"]'); if (!box) return;
    var slides = [].slice.call(box.children).filter(function (s) { return s.classList.contains('crh-slider-item'); });
    var back = root.querySelector('.crh-carousel-action-back'), next = root.querySelector('.crh-carousel-action-next');
    var n = slides.length, sw = 0, sp = 0, step = 0, pos = 0, loop = false, ready = false, anim = null, near = false, engaged = false;
    function layout() {
      var d = devBy(W.innerWidth), pv = conf.pv[d] || 1, w = box.clientWidth;
      sp = conf.sp[d] || 0; loop = !!conf.loop[d];
      if (!w) { ready = false; return; }
      sw = Math.round((w - sp * (pv - 1)) / pv); step = sw + sp;
      if (!ready) {
        // the gap is now carried by the transforms, like the original slider did
        ['--cg', '--cg-tablet', '--cg-mobile'].forEach(function (v) { box.style.removeProperty(v); });
        ready = true;
      }
      slides.forEach(function (s) { s.style.minWidth = sw + 'px'; s.style.maxWidth = sw + 'px'; });
      render();
    }
    function wrapPos(p) { var T = n * step; return ((p + step) % T + T) % T - step; }
    function render() {
      slides.forEach(function (s, i) {
        var p = i * step - pos; if (loop) p = wrapPos(p);
        s.style.transform = 'translate3d(' + Math.round(p - i * sw) + 'px, 0px, 0px)';
      });
      if (!loop) { arrowState(back, pos <= 0); arrowState(next, pos >= (n - 1) * step); }
    }
    function sized(base, w) { return /\.(gif|webp|jfif|svg|tiff?)(\?|$)/i.test(base) ? base : base + (base.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
    function unveil(i, eager) {
      var s = slides[i], im = s && s.querySelector('img[data-crh-lazy]'); if (!im) return;
      var w = Math.round((im.offsetWidth || sw) * 1.5) || 1;
      each(s.querySelectorAll('source[data-crh-lazy]'), function (so) { so.setAttribute('srcset', sized(so.getAttribute('data-crh-lazy'), w) + ' ' + (so.getAttribute('media') === '(max-width: 767px)' ? '767w' : '1023w')); so.removeAttribute('data-crh-lazy'); });
      if (eager) im.loading = 'eager';
      var u = sized(im.getAttribute('data-crh-lazy'), w);
      im.setAttribute('srcset', u + ' 767w'); im.setAttribute('src', u); im.removeAttribute('data-crh-lazy');
    }
    function load() {
      if (!near || !ready) return;
      var w = box.clientWidth, a = Math.floor(pos / step), b = Math.floor((pos + w - 1) / step), pad = engaged ? 1 : 0;
      for (var k = a - pad; k <= b + pad; k++) {
        var i = loop ? ((k % n) + n) % n : k; if (i < 0 || i >= n) continue;
        unveil(i, k < a || k > b);
      }
    }
    function engage() { if (!engaged) { engaged = true; load(); } }
    function animateTo(target, dur, ease) {
      if (anim) cancelAnimationFrame(anim.id);
      var from = pos, t0 = null;
      anim = { id: raf(function tick(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur); pos = from + (target - from) * ease(k); render();
        if (k < 1) anim.id = raf(tick);
        else { anim = null; if (loop) { pos = ((pos % (n * step)) + n * step) % (n * step); render(); } load(); }
      }) };
    }
    function goBy(d) {
      if (!ready) return;
      engage();
      var t = (Math.round(pos / step) + d) * step;
      if (!loop) t = Math.max(0, Math.min((n - 1) * step, t));
      animateTo(t, conf.speed, anim ? easeOutQuint : easeIn);
    }
    if (back) back.addEventListener('click', function () { goBy(-1); });
    if (next) next.addEventListener('click', function () { goBy(1); });
    var g = null;
    box.addEventListener('touchstart', function (e) {
      if (!ready || !conf.drag[devBy(W.innerWidth)]) return;
      engage();
      if (anim) { cancelAnimationFrame(anim.id); anim = null; }
      var p = e.touches[0]; g = { x0: p.clientX, y0: p.clientY, last: p.clientX, start: pos, axis: null, vdir: 0, moved: false };
    }, { passive: true });
    box.addEventListener('touchmove', function (e) {
      if (!g) return;
      var p = e.touches[0], dx = p.clientX - g.x0, dy = p.clientY - g.y0;
      if (g.axis === null) {
        if (dx * dx + dy * dy < 25) return;
        g.axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
      }
      if (g.axis !== 'x') { g = null; return; }
      if (e.cancelable) e.preventDefault();
      if (p.clientX !== g.last) g.vdir = p.clientX < g.last ? 1 : -1;
      g.last = p.clientX; g.moved = true;
      pos = g.start - dx;
      if (!loop) { var max = (n - 1) * step; if (pos < 0) pos = -Math.pow(-pos, 0.85); if (pos > max) pos = max + Math.pow(pos - max, 0.85); }
      box.scrollLeft = 0; render();
    }, { passive: false });
    function end() {
      if (!g) return; var s = g; g = null; if (!s.moved) return;
      swallowNextClick(root);
      var dir = s.vdir || (pos > s.start ? 1 : -1), k = pos / step;
      var target = (dir > 0 ? Math.ceil(k) : Math.floor(k)) * step;
      if (!loop) target = Math.max(0, Math.min((n - 1) * step, target));
      animateTo(target, 500, easeOutQuint);
    }
    box.addEventListener('touchend', end); box.addEventListener('touchcancel', end);
    box.addEventListener('scroll', function () { if (box.scrollLeft) box.scrollLeft = 0; });
    layout();
    W.addEventListener('resize', layout);
    if ('IntersectionObserver' in W) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); near = true; load(); } }); }, { rootMargin: '450px 0px' });
      io.observe(box);
    } else { near = true; load(); }
  }

  function carousels() {
    each(D.querySelectorAll('[data-crh] [data-crh-carousel]'), function (root) {
      var conf; try { conf = JSON.parse(root.getAttribute('data-crh-carousel')); } catch (e) { return; }
      if (conf.type === 'keen') LoopCarousel(root, conf); else RowCarousel(root, conf);
    });
  }

  /* ---------------------------------------------------------------- 4. "As seen on" logo strip
     Two copies of the logo row scroll left forever (CSS animation crh-marquee-scroll). Speed 0.4 = 40 px/s; the
     row is stretched to the strip's width on the devices listed in data-crh-full, and enough copies are added
     to cover the strip. Same maths as before, recalculated when the strip resizes. */
  function marquees() {
    each(D.querySelectorAll('[data-crh] [data-crh-el="marquee"]'), function (m) {
      var cont = m.querySelector('.crh-mq-marquee-container'), first = m.querySelector('.crh-mq-initial-child-container');
      var tracks = m.querySelectorAll('.crh-mq-marquee'), child = m.querySelector('.crh-mq-child');
      var extra = m.querySelector('.placeholder-marquee'), mainTrack = tracks[0];
      if (!cont || !first || !child || !tracks.length) return;
      var speed = 100 * (parseFloat(m.getAttribute('data-crh-speed')) || 1);
      var full = (m.getAttribute('data-crh-full') || '').split(',');
      var state = {};
      function dev() { var w = W.innerWidth; return w < 768 ? 'mobile' : (w < 1025 ? 'tablet' : 'desktop'); }
      function fill(track, count) {
        each(track.querySelectorAll('.crh-mq-child-placeholder'), function (c) { track.removeChild(c); });
        var f = D.createDocumentFragment();
        for (var k = 0; k < count; k++) { var c = child.cloneNode(true); c.classList.add('crh-mq-child-placeholder'); f.appendChild(c); }
        track.appendChild(f);
      }
      function calc() {
        var isFull = full.indexOf(dev()) >= 0, cw = cont.getBoundingClientRect().width, mw;
        if (isFull) { first.style.width = cw + 'px'; mw = cw; } else { first.style.width = 'auto'; mw = first.getBoundingClientRect().width; }
        var mult = (cw && mw) ? Math.min(60, mw < cw ? Math.ceil(cw / mw) + 1 : 1) : 2;
        var dur = mw * mult / speed;
        each(tracks, function (t) { t.style.setProperty('--duration', dur + 's'); });
        if (mult !== state.mult || cw !== state.cw || mw !== state.mw) {
          state = { mult: mult, cw: cw, mw: mw };
          fill(mainTrack, mult - 1); if (extra) fill(extra, mult);
        }
      }
      raf(function () {
        calc();
        if ('ResizeObserver' in W) {
          var pending = null;
          var ro = new ResizeObserver(function () { if (pending) return; pending = raf(function () { pending = null; calc(); }); });
          ro.observe(cont); ro.observe(first);
        } else W.addEventListener('resize', calc);
      });
    });
  }

  /* ---------------------------------------------------------------- 5. video (s03)
     The <video> ships with data-src/data-poster only; they are applied when it is within 300px of the screen
     (a slide that is off to the side counts as off screen). Clicking the thumbnail hides it and plays. */
  function videos() {
    var vids = D.querySelectorAll('[data-crh] video.crh-lazyload-video');
    function apply(v) {
      if (v.getAttribute('data-ll-status')) return;
      v.setAttribute('data-ll-status', 'loading'); v.classList.add('entered', 'loading');
      var p = v.getAttribute('data-poster'), s = v.getAttribute('data-src');
      if (p) v.setAttribute('poster', p);
      if (s) v.setAttribute('src', s);
      v.addEventListener('loadeddata', function () { v.classList.remove('loading'); v.classList.add('loaded'); v.setAttribute('data-ll-status', 'loaded'); }, { once: true });
      try { v.load(); } catch (e) {}
    }
    if ('IntersectionObserver' in W) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting || e.intersectionRatio > 0) { io.unobserve(e.target); apply(e.target); } });
      }, { rootMargin: '300px' });
      each(vids, function (v) { io.observe(v); });
    } else each(vids, apply);
    each(D.querySelectorAll('[data-crh] [data-crh-el="embed"]'), function (em) {
      var th = em.querySelector('.crh-thumbnail-video'), v = em.querySelector('video');
      if (th) th.addEventListener('click', function () { th.style.display = 'none'; if (v) v.play(); });
    });
  }

  deferImages();
  onReady(function () {
    hashLinks();
    carousels();
    marquees();
    videos();
  });
})();
